(function () {
  const PRODUCT_HANDLE = "verracream";
  const FREE_GIFT_KEY = "_free_gift";
  let busy = false;

  async function addFree(variantId) {
    if (!variantId) return null;

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { [FREE_GIFT_KEY]: true }, // mark free gift
      }),
    });

    return res.json();
  }

  async function removeFree(key) {
    if (!key) return null;

    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: key,
        quantity: 0,
      }),
    });

    return res.json();
  }

  async function syncGift(cart) {
    if (busy || !cart?.items) return;
    busy = true;

    let paidQty = 0;
    let freeItem = null;
    let variantId = null;

    cart.items.forEach((item) => {
      if (item.handle === PRODUCT_HANDLE) {
        if (item.properties?.[FREE_GIFT_KEY]) {
          freeItem = item;
        } else {
          paidQty += item.quantity;
          variantId = item.variant_id;
        }
      }
    });

    let updatedCart = null;

    // ✅ BUY 2 GET 1 FREE
    if (paidQty >= 2 && !freeItem) {
      updatedCart = await addFree(variantId);
    }

    // ✅ REMOVE FREE IF CONDITION FAILS OR CART EMPTY
    if ((paidQty < 2 || paidQty === 0) && freeItem) {
      updatedCart = await removeFree(freeItem.key);
    }

    if (updatedCart) {
      document.dispatchEvent(
        new CustomEvent("cart:change", {
          detail: { cart: updatedCart },
        })
      );
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }

    busy = false;
  }

  // Prestige real-time hook
  document.addEventListener("cart:change", (e) => {
    if (!e.detail?.cart) return;
    syncGift(e.detail.cart);
  });

  // Backup: page load par bhi sync
  fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => syncGift(cart));
})();
